export default __webpack_public_path__ + "static/media/services5.4497e8c6.jpg";